import { PaymentDTO } from '@iota/inh-core-v1-management-client';
import { createReducer, createSelector, on } from '@ngrx/store';
import { LoadB2CPayments, LoadB2CPaymentsFailure, LoadB2CPaymentsSuccess } from '../actions/b2c-employee.actions';
import { AppState } from '../store';

export interface B2CEmployeeState {
    payments: PaymentDTO[];
    loading: boolean;
    error: any;
}

export const initialB2CEmployeeState: B2CEmployeeState = {
    payments: [],
    loading: false,
    error: null
};

export const b2cEmployeeReducer = createReducer(
    initialB2CEmployeeState,

    on(LoadB2CPayments, (state) => ({
        ...state,
        loading: true,
        error: null
    })),

    on(LoadB2CPaymentsSuccess, (state, { payments }) => ({
        ...state,
        payments,
        loading: false,
        error: null
    })),

    on(LoadB2CPaymentsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    }))
);

export const b2cEmployeeState = (state: AppState) => state.b2cEmployeeState;
export const selectB2CPayments = createSelector(b2cEmployeeState, (state) => state.payments);
export const selectB2CPaymentsLoading = createSelector(b2cEmployeeState, (state) => state.loading);
